const objectOptions = [
  { id: 1, title: 'Vous souhaiteriez intégrer un réseau' },
  {
    id: 2,
    title:
      'Vous souhaiteriez proposer au Réseau AD un partenariat / Accord Cadre',
  },
  {
    id: 3,
    title: 'Vous souhaiteriez vous entretenir avec le pôle marketing digital',
  },
  { id: 4, title: 'Autres' },
];

export default objectOptions;
